"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TLSError = exports.ResponseError = void 0;
exports.toTLSError = toTLSError;
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var ResponseError = exports.ResponseError = /*#__PURE__*/function (_Error) {
  _inherits(ResponseError, _Error);
  var _super = _createSuper(ResponseError);
  function ResponseError(response) {
    var _this;
    _classCallCheck(this, ResponseError);
    _this = _super.call(this);
    var error = parseError(response);
    _this.message = error.message || error;
    _this.code = error.code;
    _this.status = response.status;
    _this.headers = response.headers;
    _this.body = response.body;
    return _this;
  }
  return _createClass(ResponseError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
function parseError(res) {
  if (res.status === 502) {
    return 'No connection with server';
  }
  return res.body || "Status Code ".concat(res.status, " (").concat(res.statusText, ")");
}

/**
 * An error which is raised when a TLS connection can not be established.
 *
 * A raw TLS failure surfaces as an opaque socket error (ECONNRESET, EPROTO, an OpenSSL code),
 * which makes the most common operational failures - a missing, rejected or expired client
 * certificate - indistinguishable from a network problem.
 *
 * Never put any part of the certificate, the private key or the passphrase into the message,
 * the reasons below are the only text this error is built from.
 */
var TLSError = exports.TLSError = /*#__PURE__*/function (_Error2) {
  _inherits(TLSError, _Error2);
  var _super2 = _createSuper(TLSError);
  function TLSError(reason, cause) {
    var _this2;
    _classCallCheck(this, TLSError);
    _this2 = _super2.call(this, cause && cause.code ? "".concat(reason, " (").concat(cause.code, ")") : reason);
    _this2.name = 'TLSError';
    _this2.code = cause && cause.code || 'TLS_ERROR';
    if (cause) {
      _this2.cause = cause;
    }
    return _this2;
  }
  return _createClass(TLSError);
}( /*#__PURE__*/_wrapNativeSuper(Error)); // the local certificate/key material can not even be loaded, the connection is never attempted
var SECURE_CONTEXT_REASONS = [{
  match: /bad decrypt|bad password read|wrong final block length/i,
  reason: 'The private key could not be decrypted, the passphrase is missing or incorrect.'
}, {
  match: /no start line|not enough data|PEM_read_bio|DECODER routines/i,
  reason: 'The client certificate or the private key is not valid PEM.'
}, {
  match: /key values mismatch/i,
  reason: 'The private key does not match the client certificate.'
}];

// the server refused our client certificate during the handshake
var HANDSHAKE_ALERT_REASONS = [{
  // the server demands a client certificate before it looks at anything else, including auth
  match: /certificate[ _]required/i,
  reason: 'The server requires a client certificate and none was supplied.'
}, {
  match: /certificate expired/i,
  reason: 'The server rejected the client certificate because it has expired.'
}, {
  match: /certificate revoked/i,
  reason: 'The server rejected the client certificate because it has been revoked.'
}, {
  match: /unknown ca/i,
  reason: 'The server does not trust the authority which issued the client certificate.'
}, {
  match: /(bad|unsupported|unknown|no) certificate/i,
  reason: 'The server rejected the client certificate.'
}, {
  match: /handshake failure/i,
  reason: 'The server rejected the TLS handshake, the client certificate is missing or was rejected.'
}];

// the certificate presented by the server could not be verified
var NO_CA_REASON = 'The server certificate could not be verified, a CA bundle may be required.';
var PEER_CERTIFICATE_REASONS = {
  CERT_HAS_EXPIRED: 'The server certificate has expired.',
  CERT_NOT_YET_VALID: 'The server certificate is not valid yet.',
  SELF_SIGNED_CERT_IN_CHAIN: 'The server certificate chain is self signed, a CA bundle may be required.',
  DEPTH_ZERO_SELF_SIGNED_CERT: 'The server certificate is self signed, a CA bundle may be required.',
  ERR_TLS_CERT_ALTNAME_INVALID: 'The server certificate does not match the requested host.',
  UNABLE_TO_VERIFY_LEAF_SIGNATURE: NO_CA_REASON,
  UNABLE_TO_GET_ISSUER_CERT_LOCALLY: NO_CA_REASON
};
function findReason(reasons, text) {
  var found = reasons.find(function (_ref) {
    var match = _ref.match;
    return match.test(text);
  });
  return found && found.reason;
}
function findPeerCertificateReason(code) {
  return code && PEER_CERTIFICATE_REASONS.hasOwnProperty(code) ? PEER_CERTIFICATE_REASONS[code] : undefined;
}

/**
 * Converts a low level socket/OpenSSL failure into a TLSError with an actionable message.
 *
 * @param {Error} error the error raised by the http client
 * @param {Boolean} withClientCert whether a client certificate was supplied for this request
 * @returns {TLSError|null} null when the error is not TLS related and should be reported as is
 */
function toTLSError(error, withClientCert) {
  if (!error) {
    return null;
  }
  var text = "".concat(error.code || '', " ").concat(error.message || '');
  var reason = findPeerCertificateReason(error.code) || findReason(SECURE_CONTEXT_REASONS, text) || findReason(HANDSHAKE_ALERT_REASONS, text);
  if (reason) {
    return new TLSError(reason, error);
  }

  // a server which demands a client certificate usually just drops the connection when it does not
  // get one it accepts, there is no alert to read, so this is the best guess we can offer
  if (withClientCert && (error.code === 'ECONNRESET' || error.code === 'EPROTO')) {
    return new TLSError('The connection was closed during the TLS handshake, ' + 'the client certificate was most likely missing, rejected or expired.', error);
  }
  return null;
}